import { dashboard } from './dashboard'
import { extInstitutions } from './ext-institution'
import { recapExtWorker } from './ext-worker'
import { farmerInstitution } from './farmer-institution'
import { ktgWorker } from './ktg-worker-list'
import { listGapoktan } from './list-gapoktan'
import { listKep } from './list-kep'
import { listMemberPoktan } from './list-member-poktan'
import { listPoktan } from './list-poktan'
import { recapClassPoktan } from './recap-class-poktan'
import { recapExtClass } from './recap-ext-class'
import { recapExtInstitution } from './recap-ext-institution'
import { recapPoktan } from './recap-poktan'
import { recapShapeKep } from './recap-shape-kep'
import { bppReference } from './reference/bpp'
import { educationReference } from './reference/education'
import { genderReference } from './reference/gender'
import { instansiReference } from './reference/instansi'
import { penyuluhPositionReference } from './reference/penyuluh-position'
import { penyuluhStatusReference } from './reference/penyuluh-status'
import { penyuluhTypeReference } from './reference/penyuluh-type'
import { poktanReference } from './reference/poktan'
import { poktanClassReference } from './reference/poktan-class'
import { poktanProgramReference } from './reference/poktan-program'
import { poktanTypeReference } from './reference/poktan-type'
import { poktanUsahaReference } from './reference/poktan-usaha'
import { posluhdesReference } from './reference/posluhdes'
import { ppTypeReference } from './reference/pp-type'
import { skillReference } from './reference/skill'
import { wilayahReference } from './reference/wilayah'
import { search } from './search'

export const guest = {
  dashboard,
  extInstitutions,
  recapExtInstitution,
  recapExtClass,
  recapExtWorker,
  ktgWorker,
  farmerInstitution,
  recapPoktan,
  recapClassPoktan,
  recapShapeKep,
  listPoktan,
  listMemberPoktan,
  listGapoktan,
  listKep,
  reference: {
    instansi: instansiReference,
    wilayah: wilayahReference,
    bpp: bppReference,
    posluhdes: posluhdesReference,
    poktan: poktanReference,
    poktanClass: poktanClassReference,
    poktanUsaha: poktanUsahaReference,
    poktanType: poktanTypeReference,
    poktanProgram: poktanProgramReference,
    ppType: ppTypeReference,
    gender: genderReference,
    penyuluhType: penyuluhTypeReference,
    penyuluhPosition: penyuluhPositionReference,
    penyuluhStatus: penyuluhStatusReference,
    education: educationReference,
    skill: skillReference
  },
  search
}
